module.exports = __webpack_public_path__ + "static/media/swatchhazeblueexclusive.4d05db99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/swatchhazeblueexclusive.png
// module id = 620
// module chunks = 0